/**
 Content container (wrapper) of login logic
 Root layer of layout
 */
import React from 'react';
import auth from '../modules/Auth0_setup';
import {Redirect} from 'react-router-dom';
import {connect} from 'react-redux';
import {getProfile, getProfileError, changeTabPage, resetProfile} from "../actions/getProfile";
import {bindActionCreators} from "redux";
import NavBarTop from "../components/main-header-nav";
import MainFooter from '../components/main-footer';
import '../css/login-container.css';
import '../css/sticky-top-nav.css';
import SecondaryNav from "../components/secondary-nav";
import {startFetchingSubscriptionList} from "../actions/getSubscriptions";
import {SELECTED_PAGE} from "../common/constants";

class DashboardContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSecondaryNavSticky: false
        }
    }

    componentWillMount() {
        if (!auth.isAuthenticated()) {
            this.props.getProfileError('Unauthenticated');
        } else {
            this.getProfile();
            this.getSubscriptionStatus();
        }
    }

    getProfile() {
        console.log("Fetching user profile...");
        this.props.getProfile();
    }

    getSubscriptionStatus() {
        this.props.startFetchingSubscriptionList();
    }

    componentDidMount() {
        const heightOfMainHeader = 50;
        window.addEventListener('scroll', () => this.checkScrollOffset(window, heightOfMainHeader));
    }

    checkScrollOffset(window, heightOfMainHeader) {
        const yOffset = window.scrollY;
        if (yOffset > heightOfMainHeader) {
            this.setState({isSecondaryNavSticky: true})
        } else {
            this.setState({isSecondaryNavSticky: false})
        }
    }

    render() {
        const {profile, loading, error, selectedPage} = this.props
        if (loading) {
            return (
                <div>Loading... If it didn't automatically redirect please refresh.</div>
            )
        }

        if (error) {
            console.log(JSON.stringify(error));
            auth.logout();
            this.props.resetProfile();
            return selectedPage === SELECTED_PAGE.ACCOUNT_SETTING_PAGE ? <Redirect to={{ pathname: '/login', state: {showAccountPage: true}}}/> : <Redirect to='/login'/>;
        }

        if (profile && profile.email_verified === false) {
            auth.logout();
            this.props.resetProfile();
            return <Redirect to={{
                pathname: '/verificationError',
                state: {userId: profile.sub}
            }}/>;
        }
        
        console.log(profile);

        if (profile && profile["https://sprintray.com/app_metadata"] && !localStorage.getItem(profile.sub + '.isTutorialFinished')) {
            const userAppMetaData = profile["https://sprintray.com/app_metadata"];
            if (userAppMetaData["is_first_time_login"]) {
                localStorage.setItem(profile.sub + '.isTutorialFinished', 'true');
                return <Redirect to='/printer-connecting-tutorial'/>
            }
        }

        
        const isSecondaryNavSticky = this.state.isSecondaryNavSticky;
        return (
            <div className={isSecondaryNavSticky ? 'topPaddingOnContainerIfSticky' : ''}>
                {isSecondaryNavSticky ? <div/> : <NavBarTop nickname={profile.nickname}/>}
                {this.getSecondaryNavTabs()}
                <div className='container'>
                    <div className='margin-between-title-and-content'>
                        {this.props.children}
                    </div>
                </div>
                <MainFooter/>
            </div>
        );
    }

    getSecondaryNavTabs() {
        const isSticky = this.state.isSecondaryNavSticky;
        const profile = this.props.profile;
        return <SecondaryNav
            isSticky={isSticky}
            profile={profile}
            changePage={this.changePage.bind(this)}
            selectedPage={this.props.selectedPage}
            showPanelTabs={this.props.showPanelTabs}
        />;
    }

    changePage(pageNum) {
        this.props.changeTabPage(pageNum);
    }
}

const mapStateToProps = state => ({...state.userProfile});
const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getProfile,
        getProfileError,
        changeTabPage,
        startFetchingSubscriptionList,
        resetProfile
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContent);


// WEBPACK FOOTER //
// ./src/containers/dashboard-login-container.js